import * as api from '../../../clients/kommunikation';

import {Action} from '@ngrx/store';

export const POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS = '[KommunikationModul] PostUpdateTroubleTicketMandantOptions laden';
export const POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_AUSFUEHREN = '[KommunikationModul] PostUpdateTroubleTicketMandantOptions ausführen';
export const POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_ERFOLGREICH = '[KommunikationModul] PostUpdateTroubleTicketMandantOptions laden erfolgreich';
export const POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_FEHLER = '[KommunikationModul] PostUpdateTroubleTicketMandantOptions Ladefehler';
export const POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[KommunikationModul] PostUpdateTroubleTicketMandantOptions nicht ausgeführt (evtl. Offline)';


export class PostUpdateTroubleTicketMandantOptionsAction implements Action {
    readonly type = POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS;
        constructor(public troubleTicketMandantOptions: api.TroubleTicketMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateTroubleTicketMandantOptionsAusfuehrenAction implements Action {
    readonly type = POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public troubleTicketMandantOptions: api.TroubleTicketMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateTroubleTicketMandantOptionsErfolgreichAction implements Action {
    readonly type = POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public troubleTicketMandantOptions: api.TroubleTicketMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateTroubleTicketMandantOptionsFehlerAction implements Action {
    readonly type = POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public troubleTicketMandantOptions: api.TroubleTicketMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateTroubleTicketMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type KommunikationCommandUpdateTroubleTicketMandantOptionsActions =
    PostUpdateTroubleTicketMandantOptionsAction
    | PostUpdateTroubleTicketMandantOptionsAusfuehrenAction
    | PostUpdateTroubleTicketMandantOptionsErfolgreichAction
    | PostUpdateTroubleTicketMandantOptionsFehlerAction
    | PostUpdateTroubleTicketMandantOptionsNichtAusgefuehrtAction
    ;
